export default __webpack_public_path__ + "static/media/FusesImg.31709856.jpg";